import store from '../store';

export enum Permission {
  NAV_DASHBOARD = 'NAV_DASHBOARD',
  NAV_USER_ROLE = 'NAV_USER_ROLE',
  NAV_TAX = 'NAV_TAX',
  NAV_POS = 'NAV_POS',
  NAV_TASK = 'NAV_TASK',
  NAV_BRAND = 'NAV_BRAND',
  NAV_OUTLET = 'NAV_OUTLET',
  NAV_TICKET = 'NAV_TICKET',
  NAV_SERVICE = 'NAV_SERVICE',
  NAV_PRODUCT = 'NAV_PRODUCT',
  NAV_INVOICE = 'NAV_INVOICE',
  NAV_ACCOUNT = 'NAV_ACCOUNT',
  NAV_LOYALTY = 'NAV_LOYALTY',
  NAV_EMPLOYEE = 'NAV_EMPLOYEE',
  NAV_SUPPLIER = 'NAV_SUPPLIER',
  NAV_CATEGORY = 'NAV_CATEGORY',
  NAV_CUSTOMER = 'NAV_CUSTOMER',
  NAV_INVENTORY = 'NAV_INVENTORY',
  NAV_GIFT_CARD = 'NAV_GIFT_CARD',
  NAV_PAYMENT_MODE = 'NAV_PAYMENT_MODE',
  NAV_SUB_CATEGORY = 'NAV_SUB_CATEGORY',
  NAV_PURCHASE_ORDER = 'NAV_PURCHASE_ORDER',
  NAV_CUSTOMER_GROUP = 'NAV_CUSTOMER_GROUP',
  NAV_MEASURMENT_UNIT = 'NAV_MEASURMENT_UNIT',
  NAV_OUTLET_INVENTORY = 'NAV_OUTLET_INVENTORY',
  NAV_COUPONS_REFERRAL = 'NAV_COUPONS_REFERRAL',

  NAV_SALES_COMPARISON = 'NAV_SALES_COMPARISON',
  NAV_TOP_CUSTOMERS_AND_PRODUCTS = 'NAV_TOP_CUSTOMERS_AND_PRODUCTS',

  TOP_CUSTOMERS_AND_PRODUCTS_LIST = 'NAV_TOP_CUSTOMERS_AND_PRODUCTS_LIST',
  SALES_COMPARISON_LIST = 'SALES_COMPARISON_LIST',

  USER_ROLE_ADD = 'USER_ROLE_ADD',
  USER_ROLE_UPDATE = 'USER_ROLE_UPDATE',
  USER_ROLE_DELETE = 'USER_ROLE_DELETE',
  USER_ROLE_ACTIVE_DEACTIVE = 'USER_ROLE_ACTIVE_DEACTIVE',
  USER_ROLE_LIST = 'USER_ROLE_LIST',

  TAX_ADD = 'TAX_ADD',
  TAX_UPDATE = 'TAX_UPDATE',
  TAX_DELETE = 'TAX_DELETE',
  TAX_ACTIVE_DEACTIVE = 'TAX_ACTIVE_DEACTIVE',
  TAX_LIST = 'TAX_LIST',
  TAX_VIEW = 'TAX_VIEW',

  TASK_ADD = 'TASK_ADD',
  TASK_UPDATE = 'TASK_UPDATE',
  TASK_DELETE = 'TASK_DELETE',
  TASK_LIST = 'TASK_LIST',

  BRAND_ADD = 'BRAND_ADD',
  BRAND_UPDATE = 'BRAND_UPDATE',
  BRAND_DELETE = 'BRAND_DELETE',
  BRAND_ACTIVE_DEACTIVE = 'BRAND_ACTIVE_DEACTIVE',
  BRAND_LIST = 'BRAND_LIST',
  BRAND_VIEW = 'BRAND_VIEW',

  OUTLET_ADD = 'OUTLET_ADD',
  OUTLET_UPDATE = 'OUTLET_UPDATE',
  OUTLET_DELETE = 'OUTLET_DELETE',
  OUTLET_ACTIVE_DEACTIVE = 'OUTLET_ACTIVE_DEACTIVE',
  OUTLET_LIST = 'OUTLET_LIST',
  OUTLET_VIEW = 'OUTLET_VIEW',
  OUTLET_SALES_REPORT='OUTLET_SALES_REPORT',

  TICKET_ADD = 'TICKET_ADD',
  TICKET_UPDATE = 'TICKET_UPDATE',
  TICKET_DELETE = 'TICKET_DELETE',
  TICKET_LIST = 'TICKET_LIST',

  SERVICE_ADD = 'SERVICE_ADD',
  SERVICE_UPDATE = 'SERVICE_UPDATE',
  SERVICE_DELETE = 'SERVICE_DELETE',
  SERVICE_ACTIVE_DEACTIVE = 'SERVICE_ACTIVE_DEACTIVE',
  SERVICE_LIST = 'SERVICE_LIST',
  SERVICE_VIEW = 'SERVICE_VIEW',

  PRODUCT_ADD = 'PRODUCT_ADD',
  PRODUCT_UPDATE = 'PRODUCT_UPDATE',
  PRODUCT_DELETE = 'PRODUCT_DELETE',
  PRODUCT_ACTIVE_DEACTIVE = 'PRODUCT_ACTIVE_DEACTIVE',
  PRODUCT_LIST = 'PRODUCT_LIST',
  PRODUCT_VIEW = 'PRODUCT_VIEW',

  INVOICE_ADD = 'INVOICE_ADD',
  INVOICE_UPDATE = 'INVOICE_UPDATE',
  INVOICE_DELETE = 'INVOICE_DELETE',
  INVOICE_ACTIVE_DEACTIVE = 'INVOICE_ACTIVE_DEACTIVE',
  INVOICE_LIST = 'INVOICE_LIST',
  INVOICE_VIEW = 'INVOICE_VIEW',

  ACCOUNT_ADD = 'ACCOUNT_ADD',
  ACCOUNT_UPDATE = 'ACCOUNT_UPDATE',
  ACCOUNT_DELETE = 'ACCOUNT_DELETE',
  ACCOUNT_ACTIVE_DEACTIVE = 'ACCOUNT_ACTIVE_DEACTIVE',
  ACCOUNT_LIST = 'ACCOUNT_LIST',
  ACCOUNT_VIEW = 'ACCOUNT_VIEW',

  LOYALTY_ADD = 'LOYALTY_ADD',
  LOYALTY_UPDATE = 'LOYALTY_UPDATE',
  LOYALTY_DELETE = 'LOYALTY_DELETE',
  LOYALTY_ACTIVE_DEACTIVE = 'LOYALTY_ACTIVE_DEACTIVE',
  LOYALTY_LIST = 'LOYALTY_LIST',
  LOYALTY_VIEW = 'LOYALTY_VIEW',

  EMPLOYEE_ADD = 'EMPLOYEE_ADD',
  EMPLOYEE_UPDATE = 'EMPLOYEE_UPDATE',
  EMPLOYEE_DELETE = 'EMPLOYEE_DELETE',
  EMPLOYEE_ACTIVE_DEACTIVE = 'EMPLOYEE_ACTIVE_DEACTIVE',
  EMPLOYEE_LIST = 'EMPLOYEE_LIST',
  EMPLOYEE_VIEW = 'EMPLOYEE_VIEW',
  EMPLOYEE_IMPORT_BUTTON='EMPLOYEE_IMPORT_BUTTON',
  EMPLOYEE_EXPORT_BUTTON='EMPLOYEE_EXPORT_BUTTON',
  
  SUPPLIER_ADD = 'SUPPLIER_ADD',
  SUPPLIER_UPDATE = 'SUPPLIER_UPDATE',
  SUPPLIER_DELETE = 'SUPPLIER_DELETE',
  SUPPLIER_ACTIVE_DEACTIVE = 'SUPPLIER_ACTIVE_DEACTIVE',
  SUPPLIER_LIST = 'SUPPLIER_LIST',
  SUPPLIER_VIEW = 'SUPPLIER_VIEW',

  CATEGORY_ADD = 'CATEGORY_ADD',
  CATEGORY_UPDATE = 'CATEGORY_UPDATE',
  CATEGORY_DELETE = 'CATEGORY_DELETE',
  CATEGORY_ACTIVE_DEACTIVE = 'CATEGORY_ACTIVE_DEACTIVE',
  CATEGORY_LIST = 'CATEGORY_LIST',
  CATEGORY_VIEW = 'CATEGORY_VIEW',

  CUSTOMER_ADD = 'CUSTOMER_ADD',
  CUSTOMER_UPDATE = 'CUSTOMER_UPDATE',
  CUSTOMER_DELETE = 'CUSTOMER_DELETE',
  CUSTOMER_ACTIVE_DEACTIVE = 'CUSTOMER_ACTIVE_DEACTIVE',
  CUSTOMER_LIST = 'CUSTOMER_LIST',
  CUSTOMER_VIEW = 'CUSTOMER_VIEW',
  CUSTOMER_SALES_REPORT= 'CUSTOMER_SALES_REPORT',
  CUSTOMER_IMPORT_BUTTON='CUSTOMER_IMPORT_BUTTON',
  CUSTOMER_EXPORT_BUTTON='CUSTOMER_EXPORT_BUTTON',

  INVENTORY_ADD = 'INVENTORY_ADD',
  INVENTORY_UPDATE = 'INVENTORY_UPDATE',
  INVENTORY_DELETE = 'INVENTORY_DELETE',
  INVENTORY_ACTIVE_DEACTIVE = 'INVENTORY_ACTIVE_DEACTIVE',
  INVENTORY_LIST = 'INVENTORY_LIST',
  INVENTORY_VIEW = 'INVENTORY_VIEW',

  GIFT_CARD_ADD = 'GIFT_CARD_ADD',
  GIFT_CARD_UPDATE = 'GIFT_CARD_UPDATE',
  GIFT_CARD_DELETE = 'GIFT_CARD_DELETE',
  GIFT_CARD_ACTIVE_DEACTIVE = 'GIFT_CARD_ACTIVE_DEACTIVE',
  GIFT_CARD_LIST = 'GIFT_CARD_LIST',
  GIFT_CARD_VIEW = 'GIFT_CARD_VIEW',

  PAYMENT_MODE_ADD = 'PAYMENT_MODE_ADD',
  PAYMENT_MODE_UPDATE = 'PAYMENT_MODE_UPDATE',
  PAYMENT_MODE_DELETE = 'PAYMENT_MODE_DELETE',
  PAYMENT_MODE_ACTIVE_DEACTIVE = 'PAYMENT_MODE_ACTIVE_DEACTIVE',
  PAYMENT_MODE_LIST = 'PAYMENT_MODE_LIST',
  PAYMENT_MODE_VIEW = 'PAYMENT_MODE_VIEW',

  SUB_CATEGORY_ADD = 'SUB_CATEGORY_ADD',
  SUB_CATEGORY_UPDATE = 'SUB_CATEGORY_UPDATE',
  SUB_CATEGORY_DELETE = 'SUB_CATEGORY_DELETE',
  SUB_CATEGORY_ACTIVE_DEACTIVE = 'SUB_CATEGORY_ACTIVE_DEACTIVE',
  SUB_CATEGORY_LIST = 'SUB_CATEGORY_LIST',
  SUB_CATEGORY_VIEW = 'SUB_CATEGORY_VIEW',

  PURCHASE_ORDER_ADD = 'PURCHASE_ORDER_ADD',
  PURCHASE_ORDER_UPDATE = 'PURCHASE_ORDER_UPDATE',
  PURCHASE_ORDER_DELETE = 'PURCHASE_ORDER_DELETE',
  PURCHASE_ORDER_ACTIVE_DEACTIVE = 'PURCHASE_ORDER_ACTIVE_DEACTIVE',
  PURCHASE_ORDER_LIST = 'PURCHASE_ORDER_LIST',
  PURCHASE_ORDER_VIEW = ' PURCHASE_ORDER_VIEW',

  MEASURMENT_UNIT_ADD = 'MEASURMENT_UNIT_ADD',
  MEASURMENT_UNIT_UPDATE = 'MEASURMENT_UNIT_UPDATE',
  MEASURMENT_UNIT_DELETE = 'MEASURMENT_UNIT_DELETE',
  MEASURMENT_UNIT_ACTIVE_DEACTIVE = 'MEASURMENT_UNIT_ACTIVE_DEACTIVE',
  MEASURMENT_UNIT_LIST = 'MEASURMENT_UNIT_LIST',
  MEASURMENT_UNIT_VIEW = 'MEASURMENT_UNIT_VIEW',

  COUPONS_REFERRAL_ADD = 'COUPONS_REFERRAL_ADD',
  COUPONS_REFERRAL_UPDATE = 'COUPONS_REFERRAL_UPDATE',
  COUPONS_REFERRAL_DELETE = 'COUPONS_REFERRAL_DELETE',
  COUPONS_REFERRAL_ACTIVE_DEACTIVE = 'COUPONS_REFERRAL_ACTIVE_DEACTIVE',
  COUPONS_REFERRAL_LIST = 'COUPONS_REFERRAL_LIST',
  COUPONS_REFERRAL_VIEW = 'COUPONS_REFERRAL_VIEW',

  OUTLET_INVENTORY_ADD = 'OUTLET_INVENTORY_ADD',
  OUTLET_INVENTORY_UPDATE = 'OUTLET_INVENTORY_UPDATE',
  OUTLET_INVENTORY_DELETE = 'OUTLET_INVENTORY_DELETE',
  OUTLET_INVENTORY_ACTIVE_DEACTIVE = 'OUTLET_INVENTORY_ACTIVE_DEACTIVE',
  OUTLET_INVENTORY_LIST = 'OUTLET_INVENTORY_LIST',
  OUTLET_INVENTORY_VIEW = 'OUTLET_INVENTORY_VIEW',

  CUSTOMER_GROUP_ADD = 'CUSTOMER_GROUP_ADD',
  CUSTOMER_GROUP_UPDATE = 'CUSTOMER_GROUP_UPDATE',
  CUSTOMER_GROUP_DELETE = 'CUSTOMER_GROUP_DELETE',
  CUSTOMER_GROUP_ACTIVE_DEACTIVE = 'CUSTOMER_GROUP_ACTIVE_DEACTIVE',
  CUSTOMER_GROUP_LIST = 'CUSTOMER_GROUP_LIST',
  CUSTOMER_GROUP_VIEW = 'CUSTOMER_GROUP_VIEW',
  NAV_CASHBACK_RULES = 'NAV_CASHBACK_RULES',
  CASHBACK_LIST = 'CASHBACK_LIST',
  CASHBACK_ADD = 'CASHBACK_ADD',
  CASHBACK_UPDATE = 'CASHBACK_UPDATE',
  CASHBACK_ACTIVE_DEACTIVE = 'CASHBACK_ACTIVE_DEACTIVE',
  REWARDSCOUPON_ACTIVE_DEACTIVE = 'REWARDSCOUPON_ACTIVE_DEACTIVE',
  REWARDSCOUPON_ADD = 'REWARDSCOUPON_ADD',
  REWARDSCOUPON_LIST = 'REWARDSCOUPON_LIST',
  REWARDSCOUPON_UPDATE = 'REWARDSCOUPON_UPDATE',
  PROMOTIONCOUPONS_ACTIVE_DEACTIVE = 'PROMOTIONCOUPONS_ACTIVE_DEACTIVE',
  PROMOTIONCOUPONS_UPDATE = 'PROMOTIONCOUPONS_UPDATE',
  PROMOTIONCOUPONS_ADD = 'PROMOTIONCOUPONS_ADD',
  PROMOTIONCOUPONS_LIST = 'PROMOTIONCOUPONS_LIST',
  CASHBACK_DELETE = 'CASHBACK_DELETE',
  REWARDSCOUPON_DELETE = 'REWARDSCOUPON_DELETE',
  PROMOTIONCOUPONS_DELETE = 'PROMOTIONCOUPONS_DELETE',
  REGISTER_ADD = 'REGISTER_ADD',
  REGISTER_LIST = 'REGISTER_LIST',
  REGISTER_UPDATE = 'REGISTER_UPDATE',
  REGISTER_DELETE = 'REGISTER_DELETE',
  NAV_COMPANY = 'NAV_COMPANY',
  COMPANY_LIST = 'COMPANY_LIST',
  COMPANY_ADD = 'COMPANY_ADD',
  COMPANY_UPDATE = 'COMPANY_UPDATE',
  COMPANY_DELETE = 'COMPANY_DELETE',
  COMPANY_ACTIVE_DEACTIVE = 'COMPANY_ACTIVE_DEACTIVE',
  COMPANY_SALES_REPORT = 'COMPANY_SALES_REPORT',
  CUSTOMER_GROUP = 'CUSTOMER_GROUP',
  EDIT_SERVICE_ON_POS = 'EDIT_SERVICE_ON_POS',
  REPORT_SALES_BY_OUTLET='REPORT_SALES_BY_OUTLET',
  REPORT_OUTLET="REPORT_OUTLET",
  REPORT_GIFT_CARD='REPORT_GIFT_CARD',
  REPORT_RETAIL_DASHBOARD='REPORT_RETAIL_DASHBOARD',
  CLOSURE_SUMMARY='CLOSURE_SUMMARY',
  PAYMENT_REPORTS='PAYMENT_REPORTS',
  SALES_LEDGER='SALES_LEDGER',
  CASH_MOVEMENT_REPORT='CASH_MOVEMENT_REPORT'
}

export type PermissionType = keyof typeof Permission;

export const isAuthorized: (
  permission: PermissionType | undefined,
) => boolean = (permission) => {
  const isSuperAdmin = store.getState()?.auth?.userData?.userType === 'ADMIN';

  const permissions = store.getState()?.auth?.permissions;

  if (isSuperAdmin) {
    return true;
  }

  return permission ? permissions?.includes(Permission[permission]) : true;
};
